module.exports = __webpack_public_path__ + "img/2.2f9beb04.png";